import React from "react";
import { Cube, Clock } from "@phosphor-icons/react";
import { CopyBtn } from "@/components/primitives";
import { cn, formatLovelace, formatRelativeTime, truncMid, unixToDate } from "@/lib/format";

// ---------- Next/Previous blocks "Icon + Details" card list ----------
export const BlockListCards = ({ rows, amountMode, onPickBlock, loading }) => {
  if (loading && (!rows || rows.length === 0)) {
    return (
      <div className="space-y-2">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="h-[72px] rounded-xl border border-primary/15 bg-card/30 animate-pulse" />
        ))}
      </div>
    );
  }
  if (!rows || rows.length === 0) {
    return <div className="text-[12px] text-muted-foreground/60 mono py-6">no blocks</div>;
  }
  const cols = "grid grid-cols-[auto_1.3fr_1.5fr_0.6fr_1fr_1.2fr] gap-4 items-center";
  return (
    <div data-testid="block-list-cards" className="rounded-2xl border border-primary/20 bg-card/30 backdrop-blur-md overflow-hidden">
      <div className={cn(cols, "px-5 py-3 border-b border-primary/15 text-[10px] uppercase tracking-[0.2em] text-muted-foreground mono")}>
        <span className="w-10" />
        <span>Height</span>
        <span>Time</span>
        <span className="text-right">Txs</span>
        <span className="text-right">Fees</span>
        <span className="text-right">Hash</span>
      </div>
      <div className="divide-y divide-primary/10">
        {rows.map((r, i) => (
          <div key={`${r.height}-${i}`} data-testid={`block-list-item-${i}`} className={cn(cols, "px-5 py-4 hover:bg-primary/[0.03] transition-colors")}>
            <div className="w-10 h-10 shrink-0 rounded-lg border border-primary/25 bg-primary/[0.06] flex items-center justify-center" style={{ filter: "drop-shadow(0 0 6px rgba(157,92,255,0.4))" }}>
              <Cube size={18} className="text-primary" weight="bold" />
            </div>
            <button
              type="button"
              onClick={() => onPickBlock?.(r.height)}
              className="font-heading text-[16px] text-primary text-glow hover:underline decoration-dotted underline-offset-2 text-left"
            >
              {Number(r.height).toLocaleString("en-US")}
            </button>
            <div className="min-w-0">
              <div className="font-mono text-[13px] text-foreground">{unixToDate(r.time)}</div>
              <div className="text-[10px] text-muted-foreground/60 mono mt-0.5 inline-flex items-center gap-1">
                <Clock size={10} /> {formatRelativeTime(r.time)}
              </div>
            </div>
            <span className="font-mono text-[13px] tabnum text-foreground text-right">{r.tx_count ?? 0}</span>
            <span className="font-mono text-[13px] tabnum text-muted-foreground text-right">{formatLovelace(r.fees, amountMode)}</span>
            <span className="inline-flex items-center gap-2 justify-end min-w-0">
              <span className="font-mono text-[12px] text-[#22d3ee]">{truncMid(r.hash, 10, 6)}</span>
              <CopyBtn value={r.hash} label="hash" />
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
